module.exports = __webpack_public_path__ + "img/сompare.1635ca04.svg";